import { last } from 'lodash';
import PropTypes from 'prop-types';

import { Link as RouterLink } from 'react-router-dom';
import { Typography, Box, Link, Breadcrumbs } from '@mui/material';

const Separator = <Box component="span" sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: 'text.disabled' }} />;

const LinkItem = ({ link }) => {
  const { href, name, icon } = link;
  return (
    <Link to={href} key={name} variant="body2" component={RouterLink} sx={styleLink}>
      {icon && <Box sx={styleIconWrapper}>{icon}</Box>}
      {name}
    </Link>
  );
};
const styleLink = {
  lineHeight: 2,
  display: 'flex',
  alignItems: 'center',
  color: 'text.primary',
  '& > div': { display: 'inherit' }
};
const styleIconWrapper = {
  mr: 1,
  '& svg': { width: 20, height: 20 }
};
LinkItem.propTypes = {
  link: PropTypes.object
};

const MBreadcrumbs = (props) => {
  const { links, activeLast = false, ...other } = props;
  const currentLink = last(links).name;

  const listDefault = links.map((link) => <LinkItem key={link.name} link={link} />);
  const listActiveLast = links.map((link) => (
    <div key={link.name}>
      {link.name !== currentLink ? (
        <LinkItem link={link} />
      ) : (
        <Typography variant="body2" sx={styleLinkText}>
          {currentLink}
        </Typography>
      )}
    </div>
  ));

  return (
    <Breadcrumbs separator={Separator} {...other}>
      {activeLast ? listDefault : listActiveLast}
    </Breadcrumbs>
  );
};

const styleLinkText = {
  maxWidth: 260,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  color: 'text.disabled',
  textOverflow: 'ellipsis'
};

MBreadcrumbs.propTypes = {
  links: PropTypes.array.isRequired,
  activeLast: PropTypes.bool
};

export default MBreadcrumbs;
